/**
 * ★ VY — paginação de RENDER por coluna do funil. Puro.
 *
 * Não é paginação de dados: o `LeadsProvider` continua assinando a coleção inteira (decisão da Fase 1) e a
 * coluna recebe TODOS os seus leads — só desenha os primeiros `n` e oferece "Carregar mais 50". A CONTAGEM do
 * cabeçalho, o valor de "Fechou" e a lista de motivos são sempre sobre a lista inteira, nunca sobre a fatia.
 * `n` sempre múltiplo de PAGINA: começa em PAGINA e `proximaPagina` SOMA (não troca).
 */
export const PAGINA = 50;

const lista = (leads) => (Array.isArray(leads) ? leads : []);

/** Os primeiros `n` da lista, na ordem em que vieram. */
export const fatiar = (leads, n) => lista(leads).slice(0, Math.max(0, n));

/** Quantos ficam de fora com `n` carregados (nunca negativo). */
export const restantes = (leads, n) => Math.max(0, lista(leads).length - Math.max(0, n));

/** Há mais para carregar? */
export const temMais = (leads, n) => restantes(leads, n) > 0;

/** O próximo `n`: soma uma página. */
export const proximaPagina = (n) => n + PAGINA;

/** Texto do botão: promete o que vai carregar de fato e diz quanto falta. */
export function rotuloCarregarMais(leads, n) {
  const faltam = restantes(leads, n);
  return `Carregar mais ${Math.min(PAGINA, faltam)} · ${faltam} restantes`;
}
